import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { BASE_API_URL } from '../../config';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    _retry?: boolean;
}

// Function to get a new access token
const getNewAccessToken = async (): Promise<string> => {
    try {
        // Make a request to your API endpoint to get a new access token
        const response = await axios.get('https://www.abc.com/getaccessToken', {
        // You might need to include headers or other parameters depending on your API
        });

        // Assuming the response contains the access token in the 'token' field
        const newAccessToken: string = response.data.token;

        // Store the new access token in local storage
        localStorage.setItem('access_token', newAccessToken);

        return newAccessToken;
    } catch (error) {
        console.error('Error fetching new access token:', error);
        throw error;
    }
};

const getAccessToken = (): string | null => {
    const token = localStorage.getItem('access_token');
    return token;
};


const setAccessToken = (token: string): void => {
    localStorage.setItem('access_token', token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// Create an Axios instance
const api: AxiosInstance = axios.create({
  baseURL: `${BASE_API_URL}/v1/api`,
});

// Add a request interceptor to include the Authorization header

api.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => response,
    async (error: AxiosError): Promise<any> => {
      const originalRequest: CustomAxiosRequestConfig = error.config as CustomAxiosRequestConfig;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const newAccessToken: string = await getNewAccessToken();
        if (newAccessToken) {
          localStorage.setItem('access_token', newAccessToken);
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        }
      }
      return Promise.reject(error);
    }
);

export { api, setAccessToken };